const MUTATION_REMOVE_COUPON_FROM_TOTE = `
  mutation removeCouponFromToteCart($input: RemoveCouponFromToteCartInput!) {
    RemoveCouponFromToteCart(input: $input) {
      errors {
        error_code
        message
      }
      success
      tote_cart {
        id
        state
        nth_tote        
        max_clothing_count
        max_accessory_count
        clothing_bonus_slots_sum
        accessory_bonus_slots_sum
        express_fulfillment_center_config {
          open_change_express
          popup_change_express_banner_url
          tips
        }
        accessory_items {
          ...toteCartItemFields
        }
        clothing_items {
          ...toteCartItemFields
        }
        premium_clothing_slot_count
        premium_accessory_slot_count
        premium_service {
          max_purchase_clothing_slot
          max_purchase_accessory_slot
          clothing_slot_price
          accessory_slot_price
          origin_clothing_slot_price
          origin_accessory_slot_price
        }
        has_replaced_product
        display_more_product_entry
        with_free_service
        used_free_service
        disable_free_service
        display_free_service_banner
        disable_coupon
        accessory_customer_coupon {
          customer_coupon_id
          slot_count
        }
        clothing_customer_coupon {
          customer_coupon_id
          slot_count
        }
        onboarding
        tote_cart_bottom_tips
        banner {
          url
        }
        popup {
          url
        }
        validate_result_v1(
          category_rule_flag: true
          need_category_rule_verify: true
        ) {
          errors {
            error_code
            message
          }
          success
        }
      }
    }
  }
  fragment toteCartItemFields on ToteCartItem {
    id
    product {
      catalogue_photos {
        medium_url
      }
      category_rule{
        slug
        error_msg
        swap_ban_threshold
      }
      category {
        name
        accessory
      }
      id
      type
      swappable
      tote_slot
    }
    product_size {
      id
      size_abbreviation
      size {
        id
        name
        abbreviation
      }
      swappable
    }
    slot
  }
`

const MUTATION_APPLY_COUPON_TO_TOTE = `
  mutation applyCouponToToteCart($input: ApplyCouponToToteCartInput!) {
    ApplyCouponToToteCart(input: $input) {
      errors {
        error_code
        message
      }
      success
      tote_cart {
        id
        state
        nth_tote        
        max_clothing_count
        max_accessory_count
        clothing_bonus_slots_sum
        accessory_bonus_slots_sum
        express_fulfillment_center_config {
          open_change_express
          popup_change_express_banner_url
          tips
        }
        accessory_items {
          ...toteCartItemFields
        }
        clothing_items {
          ...toteCartItemFields
        }
        premium_clothing_slot_count
        premium_accessory_slot_count
        premium_service {
          max_purchase_clothing_slot
          max_purchase_accessory_slot
          clothing_slot_price
          accessory_slot_price
          origin_clothing_slot_price
          origin_accessory_slot_price
        }
        has_replaced_product
        display_more_product_entry
        with_free_service
        used_free_service
        disable_free_service
        display_free_service_banner
        disable_coupon
        accessory_customer_coupon {
          customer_coupon_id
          slot_count
        }
        clothing_customer_coupon {
          customer_coupon_id
          slot_count
        }
        onboarding
        tote_cart_bottom_tips
        banner {
          url
        }
        popup {
          url
        }
        validate_result_v1(
          category_rule_flag: true
          need_category_rule_verify: true
        ) {
          errors {
            error_code
            message
          }
          success
        }
      }
    }
  }
  fragment toteCartItemFields on ToteCartItem {
    id
    product {
      catalogue_photos {
        medium_url
      }
      id
      type
      swappable
      tote_slot
      category_rule {
        slug
        error_msg
        swap_ban_threshold
      }
      category {
        name
        accessory
      }
    }
    product_size {
      id
      size_abbreviation
      size {
        id
        name
        abbreviation
      }
      swappable
    }
    slot
  }
`

export { MUTATION_APPLY_COUPON_TO_TOTE, MUTATION_REMOVE_COUPON_FROM_TOTE }
